import { Type } from "lucide-react";
import { useState } from "react";

import { BriefText } from "./BriefText";
import { BriefTextEditor } from "./BriefTextEditor";
import { CollapsibleCard } from "./CollapsibleCard";

type TextForDesignProps = {
  /** When provided, the text becomes editable. */
  onSave?: (value: string) => void;
  value: string;
};

export function TextForDesign({ onSave, value }: TextForDesignProps) {
  const [isEditing, setIsEditing] = useState(false);

  return (
    <CollapsibleCard
      icon={<Type className="size-5" />}
      onEdit={onSave && !isEditing ? () => setIsEditing(true) : undefined}
      title="Text for design"
    >
      {onSave && isEditing ? (
        <BriefTextEditor
          onCancel={() => setIsEditing(false)}
          onSave={onSave}
          placeholder="Add the copy for this design"
          value={value}
        />
      ) : (
        <BriefText placeholder="No text for this design yet" value={value} />
      )}
    </CollapsibleCard>
  );
}
